var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 50,
    viewBox: "0 0 65 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.075 24.7372C27.95 23.6872 29.075 21.8497 29.075 19.5622V18.9997C29.075 15.1372 26.1125 12.6997 21.5 12.6997H12.5V37.2997H22.025C26.6 37.2997 29.6 34.6747 29.6 30.6997V30.0997C29.6 27.6247 28.2875 25.7497 26.075 24.7372ZM21.5 15.8872C24.125 15.8872 25.5875 17.0872 25.5875 19.2622V19.8247C25.5875 21.9622 24.05 23.2747 21.5375 23.2747H16.025V15.8872H21.5ZM26.1125 30.5872C26.1125 32.7997 24.5375 34.1122 21.9125 34.1122H16.025V26.4247H21.95C24.5 26.4247 26.1125 27.8122 26.1125 29.9872V30.5872Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5082 12.6997H47.7582L41.4582 23.2372H37.5582V12.6997H34.0332V37.2997H37.5582V26.4247H41.3082L47.7207 37.2997H51.4707V36.7372L44.4207 24.9622L51.5082 13.2622V12.6997Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 61.0625,
    height: 47,
    stroke: "black",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.1417dcb267cf60535fddb154f1c27d7d.svg";
export { ForwardRef as ReactComponent };